import { createContext, useReducer } from "react";

import * as authActionTypes from "../constants/actionTypes/auth";
import { ROUTES } from "../constants/routes";

export const AuthContext = createContext();

const initialState = {
  userAccess: { allowedPageList: [], moduleList: [], buttonList: [] },
  loadingUserAccess: true,
  homePath: "",
  isAuthenticated: false,
  user: {},
};

const authReducer = (state, action) => {
  switch (action.type) {
    case authActionTypes.LOGIN: {
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    }

    case authActionTypes.FETCH_USER_ACCESS_SUCCESS: {
      const homeKey =
        action.payload.moduleList[0].children.length > 0
          ? action.payload.moduleList[0].children[0]
          : action.payload.moduleList[0].key;

      const homePath = ROUTES.find((route) => route.key === homeKey)?.path;

      return {
        ...state,
        userAccess: action.payload,
        loadingUserAccess: false,
        homePath,
      };
    }

    case authActionTypes.LOGOUT: {
      return initialState;
    }

    default:
      return initialState;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
